'use client';

import { Root } from '@radix-ui/react-popover';
import { ComponentPropsWithoutRef } from 'react';
import { PopoverAnchor } from './popover-anchor';
import { PopoverArrow } from './popover-arrow';
import { PopoverContent } from './popover-content';
import { PopoverTrigger } from './popover-trigger';

type Props = ComponentPropsWithoutRef<typeof Root>;
const PopoverRoot = (props: Props) => {
    return <Root data-testid="popover" {...props} />;
};

export const Popover = Object.assign(PopoverRoot, {
    Trigger: PopoverTrigger,
    Content: PopoverContent,
    Anchor: PopoverAnchor,
    Arrow: PopoverArrow,
});
